import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIImage from 'UIComponents/image/UIImage';
// @ts-expect-error static asset
import appMarketplaceImageUrl from 'bender-url!../../img/app-marketplace-network-1x.png';
// @ts-expect-error static asset
import appMarketplaceImageUrl2x from 'bender-url!../../img/app-marketplace-network-2x.png';
import { getAppMarketplaceUrl } from '../utils/urls';
import { HOME_SECTION_Y_PADDING } from './HomeSection';
import MediaSection from './MediaSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AppMarketplaceSection({
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(MediaSection, {
    button: /*#__PURE__*/_jsx(UIButton, {
      href: getAppMarketplaceUrl(),
      onClick: () => onTrackInteraction('click app marketplace section button'),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceUnified.sections.appMarketplace.buttonText"
      })
    }),
    color: "light",
    "data-test-id": "app-marketplace-section",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.appMarketplace.description"
    }),
    media: /*#__PURE__*/_jsx(UIImage, {
      src: appMarketplaceImageUrl,
      srcSet: `${appMarketplaceImageUrl2x} 2x`,
      style: {
        width: '100%',
        maxWidth: 500,
        marginBottom: HOME_SECTION_Y_PADDING * -1
      }
    }),
    orientation: "media-right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.appMarketplace.title"
    })
  });
}